<div class="sidenav-content copo-datacenter-sidenav-content" @routeAnimation>
	<div class="copo-datacenter-flex-box">
		<div class="header-container">
			<button (click)="close()" class="back-button-icon" type="button" mat-icon-button>
				<mat-icon svgIcon="md:chevron_left"></mat-icon>
			</button>
			<span class="back-button-title"><span translate>{{ filterTitle }}</span>&nbsp; - &nbsp;<span translate>datacenter.filters</span></span>
		</div>
		<div class="filter-data-container">
			<copo-datacenter-filter-customization 
				class="filter-container" #filters
				[allFilters]="allFilters"
				[addedFilters]="addedFilters"
				></copo-datacenter-filter-customization>
		</div>
		<div class="footer-container">
			<button type="button" class="apply-button" cdkFocusInitial
					mat-raised-button color="primary" (click)="applyFilters()">
				<span translate>datacenter.apply</span>
			</button>
		</div>
	</div>
</div>
